import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Title } from "@bw/bits"
import * as css from "./contentWithImage.module.css"

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props =>
    props.$justify === "center" ? "center" : `flex-${props.$justify}`};
  margin-top: 45px;
`

const ContentWithImage = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  text,
  textWidth,
  image,
  orientation,
  alignement,
}) => {
  const content = (
    <>
      {(title || suptitle || subtitle) && (
        <Title {...{ suptitle, title, subtitle }} />
      )}
      {text}
      {button && (
        <ButtonWrapper $justify={buttonPosition}>{button}</ButtonWrapper>
      )}
    </>
  )

  let classes = `${css.wrapper} ${css[`align_${alignement}`]}`

  if (orientation === "text_on_right") {
    classes += ` ${css.textOnRight}`
  }

  return (
    <div
      className={`${classes} content-on-columns content-on-columns--${orientation}`}
    >
      <div
        className={`${css.content} ${
          css[`textWidth_${textWidth}`]
        } content-on-columns__content`}
      >
        {content}
      </div>
      {image && (
        <div className={`${css.image} content-on-columns__image`}>{image}</div>
      )}
    </div>
  )
}

ContentWithImage.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.any,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  orientation: PropTypes.oneOf(["text_on_left", "text_on_right"]),
  button: PropTypes.element,
  buttonPosition: PropTypes.oneOf(["start", "center", "end"]),
}

ContentWithImage.defaultProps = {
  orientation: "text_on_left",
}

export { ContentWithImage }
